import {RouteProps} from '../../../routes/AppRouter'
import {FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField} from '@material-ui/core'
import {useForm} from '../../../common/utils/form-generation/useForm'
import {useTranslation} from 'react-i18next'
import {navigate} from '@reach/router'
import {URL_PATIENTS, URL_PATIENTS_INMUNOCOM} from '../../../routes/routes-constants'
import {ChangeEvent, FormEvent, useEffect, useRef, useState} from 'react'
import {v4 as uuidv4} from 'uuid'
import {FormAction, FormActions} from '../../../common/utils/form-generation'
import {BoolQueryParam, Query, QueryParam} from '../../../common/api/Query'
import {Clinic, ClinicQuery} from '../../../modules/clinics/models/Clinic'
import {getClinicContainer} from '../../../container/clinic-modules'
import {ClinicService} from '../../../modules/clinics/services/ClinicService'
import {CLINIC_SERVICE_KEY} from '../../../modules/clinics'
import {getPatientContainer} from '../../../container/patient-module'
import {PatientService} from '../../../modules/patients/services/PatientService'
import {PATIENT_SERVICE_KEY} from '../../../modules/patients'
import {PatientQuery, PatientReceptiveness, PatientReceptivenessDTO} from '../../../modules/patients/models/PatientReceptiveness'
import {EntitySelect} from '../../common/EntitySelect'
import {userGenders} from '../../../modules/users/enums/GenderType'
import {useStyles} from '../../../components/entity-page/EntityPage.styles'
import {getAuthContainer} from '../../../container/auth-modules'
import {AuthService} from '../../../modules/auth/services/AuthService'
import {AUTH_SERVICE_KEY} from '../../../modules/auth'
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import {toNoon} from '../../../common/dateUtils'
import {Permission} from '../../../common/enums/Permissions'
import {optionPatientLanguage} from '../../../modules/users/enums/Language'
import { Autocomplete } from '@mui/material'

const clinicService = getClinicContainer().get<ClinicService>(CLINIC_SERVICE_KEY)

const patientService = getPatientContainer().get<PatientService>(PATIENT_SERVICE_KEY)
const authService = getAuthContainer().get<AuthService>(AUTH_SERVICE_KEY)

export type FormProps = RouteProps & {
    patient: PatientReceptiveness | undefined
}

export const Form = (props: FormProps) => {
    const {t} = useTranslation()
    const classes = useStyles({})
    const [selectedFile, setSelectedFile] = useState<File>()
    const [clinics, setClinics] = useState<Clinic[]>([])
    const [patients, setPatients] = useState<PatientReceptiveness[]>([])
    const [patientsName, setPatientsName] = useState<string[]>([])
    const [selected, setSelected] = useState<string>()

    useEffect(() => {
        if (!props.patient) {
            return
        }
        setData(props.patient.toDTO())
    }, [props.patient])

    useEffect(() => {
        const query = []
        if (!authService.get().permissions.includes(Permission.viewAll)) {
            query.push(new QueryParam<ClinicQuery>('ids', authService.get().clinics))
        } else {
            query.push(new QueryParam<ClinicQuery>('receptiveness', new BoolQueryParam(true)))
        }
        clinicService
            .getFilteredList(
                new Query({
                    query,
                    sort: [{field: 'name'}],
                }),
            )
            .subscribe((res) =>{
                setClinics(res.items)
            } )
    }, [])

    useEffect(()=>{
        const query = []

        if (!authService.get().permissions.includes(Permission.viewAll)) {
            query.push(new QueryParam<PatientQuery>('clinics', authService.get().clinics))

        }
        patientService
            .getFilteredList(
                new Query({
                    query,
                    sort: [{field: "firstName", desc: false}],
                }),
            )
            .subscribe((res) => {


                let uniquePanelNames: string[] = []
                res.items.forEach((item) => {
                    if (!uniquePanelNames.includes(`${item.firstName} ${item.lastName}`)) {
                        uniquePanelNames.push(`${item.firstName} ${item.lastName}`)
                    }
                })

                setPatientsName(uniquePanelNames);
                setPatients(res.items)
            })
    }, [])

    const {handleChange, handleSubmit, data, setData, errors} = useForm<PatientReceptivenessDTO>({
        validations: {
            clinicID: {
                required: {
                    value: true,
                    message: t('clinicNotValidError'),
                },
            },
            idPatient: {
                required: {
                    value: true,
                    message: t('nhcIdPatientNotValidError'),
                },
            },
            firstName: {
                required: {
                    value: true,
                    message: t('firstNameNotValidError'),
                },
            },
            lastName: {
                required: {
                    value: true,
                    message: t('lastNameNotValidError'),
                },
            },
            gender: {
                required: {
                    value: true,
                    message: t('genderNotValidError'),
                },
            },
            clinicName: {
                required: {
                    value: true,
                    message: t('clinicNameNotValidError'),
                },
            },
            dob: {
                required: {
                    value: true,
                    message: t('dobNotValidError'),
                },
            }
        },

        onSubmit: () => {
            function storeCb(value: PatientReceptiveness | undefined) {
                if (value) {
                    if (selectedFile) {
                    } else {
                        goToPatients().then()
                    }
                }
            }

         

            if (!data.id) {
                patientService
                    .add({
                        ...data,
                        sampleName: data.sampleName,
                        pgsec: false,
                        pgd: false, 
                        receptiveness: false,
                        inmunocom: true,
                        id: uuidv4(),
                    })
                    .subscribe((value) => storeCb(value))
                return
            }

            patientService
                .update({...data,  
                    inmunocom: true
                })
                .subscribe((value) => storeCb(value))
        },

        initialValues: props.patient && props.patient.toDTO(),
    })

    const inputFile = useRef<HTMLInputElement | null>(null)

    const goToPatients = () => navigate(URL_PATIENTS_INMUNOCOM)

    const actions: FormAction[] = [
        {
            label: t('back'),
            handleAction: () => goToPatients(),
        },
    ]

const handleSend = (e: FormEvent<HTMLFormElement>) => {

   handleSubmit(e)

}

const handleChangeSelectedPatient = (newValue: string) =>{
    const selectecPatient = patients.find(p => `${p.firstName} ${p.lastName}` === newValue) 

    if (selectecPatient){
        setSelected(newValue)
        setData(selectecPatient.toDTO())

    }
}


    return (
        <form onSubmit={handleSend}>
        {!props.patient &&(
            <Grid container style={{marginBottom: "50px"}} >
                <Grid item xs={12}>
                    <FormControl fullWidth variant="outlined" >
                        <Autocomplete
                            id="patient"
                            fullWidth
                            value={(selected) || ''}
                            onChange={(_, newValue) => handleChangeSelectedPatient(newValue || '')}
                            options={patientsName}
                            getOptionLabel={(option) => option}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('patient')}
                                    fullWidth
                                    variant="outlined"
                                    style={{ textAlign: 'left' }}
                                />
                            )}
                            isOptionEqualToValue={(option, value) => option === value}
                            freeSolo 
                        />
                    </FormControl>
                </Grid>
            </Grid>)}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <EntitySelect
                        name={'name'}
                        value={data && data.clinicID}
                        options={clinics}
                        error={errors['clinicID']}
                        onChange={(value) => handleChange('clinicID', value && value.id)}
                        label={t('clinic') + ' *'}
                        pk={'id'}
                        disabled={props.patient ? true : false}
                    />
                </Grid>
              
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        variant={'outlined'}
                        error={errors['firstName'] !== undefined}
                        id={'firstName'}
                        type={'string'}
                        onChange={(event) => handleChange('firstName', event.target.value)}
                        value={(data && data.firstName) || ''}
                        label={t('firstName') + ' *'}
                        helperText={errors['firstName']}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        variant={'outlined'}
                        error={errors['lastName'] !== undefined}
                        id={'lastName'}
                        type={'string'}
                        onChange={(event) => handleChange('lastName', event.target.value)}
                        value={(data && data.lastName) || ''}
                        label={t('lastName') + ' *'}
                        helperText={errors['lastName']}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        variant={'outlined'}
                        error={errors['sampleName'] !== undefined}
                        id={'sampleName'}
                        type={'string'}
                        onChange={(event) => handleChange('sampleName', event.target.value)}
                        value={(data && data.sampleName) || ''}
                        label={t('sampleName')}
                        helperText={errors['sampleName']}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth variant='outlined' error={errors['dob'] !== undefined}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                style={{width: '100%'}}
                                id='dob'
                                autoOk
                                inputVariant={'outlined'}
                                format={t('dateFormat')}
                                value={data.dob || null}
                                onChange={(newDate) => setData(Object.assign({...data}, {dob: toNoon(newDate)}))}
                                required={false}
                                size={'small'}
                                label={t('dob')}
                            />
                        </MuiPickersUtilsProvider>
                        <FormHelperText>{errors['dob']}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        variant={'outlined'}
                        error={errors['idPatient'] !== undefined}
                        id={'name'}
                        type={'string'}
                        onChange={(event) => handleChange('idPatient', event.target.value)}
                        value={(data && data.idPatient) || ''}
                        label={t('nhcIdPatient') + ' *'}
                        helperText={errors['idPatient']}
                    />
                </Grid>
                  <Grid item xs={12}>
                    <TextField
                        fullWidth
                        variant={'outlined'}
                        error={errors['sampleType'] !== undefined}
                        id={'sampleType'}
                        type={'string'}
                        onChange={(event) => handleChange('sampleType', event.target.value)}
                        value={(data && data.sampleType) || ''}
                        label={t('sampleType') + ' *'}
                        helperText={errors['sampleType']}
                    />
                </Grid>

                <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            style={{width: '100%'}}
                            id="dateSampleType"
                            autoOk
                            inputVariant={'outlined'}
                            format={ t('dateFormat')}
                            value={data.dateSampleType || null}
                            onChange={(newDate) => setData(Object.assign({...data}, {dateSampleType: toNoon(newDate)}))}
                            required={false}
                            size={'small'}
                            label={t('dateSampleType')}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth variant='outlined' error={errors['gender'] !== undefined}>
                        <InputLabel id='inherit-label'>{t('gender') + ' *'}</InputLabel>
                        <Select
                            labelId='gender-label'
                            id='gender'
                            fullWidth
                            style={{textAlign: 'left'}}
                            value={(data && data.gender) || ''}
                            onChange={(event) =>
                                handleChange('gender', event.target.value && +(event.target.value as string))
                            }
                            label={t('gender') + ' *'}>
                            {Object.entries(userGenders()).map(([key, value]) => (
                                <MenuItem value={key}>{value}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{errors['gender']}</FormHelperText>
                    </FormControl>
                </Grid>
               
                <Grid item xs={12}>
                    <TextField
                        error={errors['geneticDiseaseHistory'] !== undefined}
                        fullWidth
                        id='geneticDiseaseHistory'
                        label={t('geneticDiseaseHistory')}
                        onChange={(event) => handleChange('geneticDiseaseHistory', event.target.value)}
                        multiline
                        rows={4}
                        value={data && data.geneticDiseaseHistory}
                        variant='outlined'
                        helperText={errors['geneticDiseaseHistory']}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        variant={'outlined'}
                        error={errors['clinicName'] !== undefined}
                        id={'name'}
                        type={'string'}
                        onChange={(event) => handleChange('clinicName', event.target.value)}
                        value={(data && data.clinicName) || ''}
                        label={t('clinicName') + ' *'}
                        helperText={errors['clinicName']}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth variant="outlined" error={errors['language'] !== undefined}>
                        <InputLabel id="language-label">{t('language')  + ' *'}</InputLabel>
                        <Select
                            labelId="language-label"
                            id="language"
                            fullWidth
                            style={{textAlign: 'left'}}
                            value={(data && data.language) || ''}
                            onChange={(event) => handleChange('language', event.target.value)}
                            label={t('language') + ' *'}>
                            {Object.keys(optionPatientLanguage()).map((l) => (
                               (l=== 'es' || l==='en') && <MenuItem value={l} key={l}>
                                    {t(l)}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{errors['language']}</FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>
            <FormActions actions={actions}/>
        </form>
    )
}